import { useEffect, useState } from "react";

function usePremium() {
  const [premiumData, setPremiumData] = useState({
    isPremium: false,
    isPremiumLite: false,
  });

  useEffect(() => {
    const appUserElement = document.querySelector("#app-user");
    if (appUserElement) {
      const isPremium = appUserElement.dataset.premium === "1";
      const isPremiumLite = appUserElement.dataset.lite === "1";
      setPremiumData({ isPremium, isPremiumLite });
    }
  }, []);

  return premiumData;
}

export default usePremium;
